import React, { useEffect, useState } from "react";

const ClockWidget = ({ config = {} }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const timeOpts = { hour: "2-digit", minute: "2-digit", hour12: config.hour12 !== false };
  if (config.tz) timeOpts.timeZone = config.tz;
  const dateOpts = { weekday: "long", month: "long", day: "numeric" };
  if (config.tz) dateOpts.timeZone = config.tz;

  return (
    <div className="sb-card sb-clock">
      <div className="sb-clock-time">{now.toLocaleTimeString([], timeOpts)}</div>
      {config.showDate !== false && (
        <div className="sb-clock-date">{now.toLocaleDateString([], dateOpts)}</div>
      )}
    </div>
  );
};

export default ClockWidget;
